class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.closeDelayMs = 180;
    this.closeTimeout = null;
    this.onMouseEnterHandler = this.onMouseEnter.bind(this);
    this.onMouseLeaveHandler = this.onMouseLeave.bind(this);
    this.onSummaryClickHandler = this.onSummaryClick.bind(this);

    this.addEventListener('mouseenter', this.onMouseEnterHandler);
    this.addEventListener('mouseleave', this.onMouseLeaveHandler);
    this.mainDetailsToggle.querySelector('summary')?.addEventListener('click', this.onSummaryClickHandler);
  }

  isDesktopHover() {
    return window.matchMedia('(hover: hover) and (pointer: fine)').matches && window.matchMedia('(min-width: 990px)').matches;
  }

  onSummaryClick(event) {
    // Desktop hover menus: ignore mouse clicks that would toggle closed.
    // Keep keyboard activation (detail === 0) working.
    if (!this.isDesktopHover() || event.detail === 0) return;
    if (this.mainDetailsToggle.open) {
      event.preventDefault();
    }
  }

  onMouseEnter() {
    if (!this.isDesktopHover()) return;

    clearTimeout(this.closeTimeout);

    document.querySelectorAll('header-menu > details[open]').forEach((details) => {
      if (details !== this.mainDetailsToggle) {
        details.removeAttribute('open');
        details.querySelector('summary')?.setAttribute('aria-expanded', 'false');
      }
    });

    this.mainDetailsToggle.setAttribute('open', '');
    this.mainDetailsToggle.querySelector('summary')?.setAttribute('aria-expanded', 'true');
  }

  onMouseLeave() {
    if (!this.isDesktopHover()) return;

    clearTimeout(this.closeTimeout);
    this.closeTimeout = setTimeout(() => this.close(), this.closeDelayMs);
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (this.mainDetailsToggle.open) {
      this.updateHeaderBottom();
      this.onHeaderPositionChange = this.onHeaderPositionChange || this.updateHeaderBottom.bind(this);
      window.addEventListener('scroll', this.onHeaderPositionChange, { passive: true });
      window.addEventListener('resize', this.onHeaderPositionChange);
    } else if (this.onHeaderPositionChange) {
      window.removeEventListener('scroll', this.onHeaderPositionChange);
      window.removeEventListener('resize', this.onHeaderPositionChange);
    }
  }

  updateHeaderBottom() {
    if (this.headerBottomFrame) return;
    this.headerBottomFrame = requestAnimationFrame(() => {
      this.headerBottomFrame = null;
      const summary = this.mainDetailsToggle?.querySelector('summary');
      if (!summary) return;
      const bottom = Math.ceil(summary.getBoundingClientRect().bottom);
      document.documentElement.style.setProperty('--header-bottom-position-desktop', `${bottom}px`);
    });
  }

  disconnectedCallback() {
    if (this.onHeaderPositionChange) {
      window.removeEventListener('scroll', this.onHeaderPositionChange);
      window.removeEventListener('resize', this.onHeaderPositionChange);
    }
  }
}

customElements.define('header-menu', HeaderMenu);
